export enum ETweakAdvancedSettings {
	TOGGLE_RATE_CALL_SURVEY = 'toggleRateCallSurvey',
	BULK_CALL_TRANSFER = 'bulkCallTransfer',
}
